import React from 'react';

const colorVar = c => ({ amb: 'amber', grn: 'green', blu: 'blue', pur: 'purple' }[c] || c);

export default function CompRow({ label, score, color, max = 100, weight, srcTag, srcTagLabel }) {
  const c = colorVar(color);
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '5px 0', borderBottom: '1px solid var(--border)' }}>
      <span style={{ fontSize: 11, color: 'var(--t1)', flex: '0 0 auto', minWidth: 90 }}>{label}</span>
      {weight != null && (
        <span style={{ fontSize: 10, color: 'var(--t3)', fontFamily: 'var(--mono)', flex: 'none' }}>{weight}</span>
      )}
      <div style={{ flex: 1, background: 'var(--bg4)', borderRadius: 2, height: 5, overflow: 'hidden' }}>
        <div style={{ height: '100%', borderRadius: 2, background: `var(--${c})`, width: `${Math.max(0, (score / max) * 100)}%`, transition: 'width .5s' }} />
      </div>
      <span style={{ fontFamily: 'var(--mono)', fontSize: 11, fontWeight: 700, width: 28, textAlign: 'right', color: `var(--${c})` }}>{score}</span>
      {srcTag && (
        <span className={`badge badge-${srcTag === 'LIVE' ? 'grn' : srcTag === 'EST' ? 'amb' : 'red'}`}>
          {srcTagLabel || srcTag}
        </span>
      )}
    </div>
  );
}
